module.exports = __webpack_public_path__ + "img/vu.f3e61ec9.svg";